import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeProc1 = ({autorizacUA, styles, handleClickSel1, handleClickSel2, handleClickSel3, handleClickSelATOS,
                    handleClickSel4, handleClickSel5, handleClickSelEC, handleClickSel6, handleClickSel7, handleClickSelCAR}) => {
  const a1001 = autorizacUA.findIndex( autorizac => autorizac === "1001" );
  const a1003 = autorizacUA.findIndex( autorizac => autorizac === "1003" );
  const a1004 = autorizacUA.findIndex( autorizac => autorizac === "1004" );
  const a1005 = autorizacUA.findIndex( autorizac => autorizac === "1005" );
  const a1010 = autorizacUA.findIndex( autorizac => autorizac === "1010" );
  const a1012 = autorizacUA.findIndex( autorizac => autorizac === "1012" );
  const a1015 = autorizacUA.findIndex( autorizac => autorizac === "1015" );
  const a1020 = autorizacUA.findIndex( autorizac => autorizac === "1020" );
  const a1022 = autorizacUA.findIndex( autorizac => autorizac === "1022" );
  const a1025 = autorizacUA.findIndex( autorizac => autorizac === "1025" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        PROCESOS
      </button>

      {a1001!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
          <i className="large money bill alternate outline violet icon"></i>
          Recibir pago - Terceros
        </button>
      }
      {a1003!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel7}>
          <i className="large money bill alternate outline violet icon"></i>
          Procesar archivos de recaudo
        </button>
      }
      {a1004!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSelCAR}>
          <i className="large money bill alternate outline violet icon"></i>
          Cargar y procesar archivo de recaudo
        </button>
      }
      {(a1001!==-1||a1003!==-1) &&
        <Divider inverted />
      }

      {a1005!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
        <i className="large hand scissors outline violet icon"></i>
        Generar DX masiva
      </button>
      }
      {a1010!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel3}>
        <i className="large cut violet icon"></i>
        Gestionar DX masiva
      </button>
      }

      <Divider inverted />

      {a1012!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSelATOS}>
        <i className="large cut violet icon"></i>
        Asignar recurso técnico a OS ABIERTA
      </button>
      }

      <Divider inverted />

      {a1015!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel4}>
        <i className="large edit violet icon"></i>
        Actualizar tarifas
      </button>
      }
      {a1020!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel5}>
        <i className="large edit violet icon"></i>
        Cambiar servicios
      </button>
      }

      {a1022!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSelEC}>
            <i className="large edit violet icon"></i>
            Clientes enviar factura por correo
          </button>
        </div>
      }

      {a1025!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel6}>
            <i className="large edit violet icon"></i>
            Administrativos
          </button>
        </div>
      }

    </div>
  )
};

export default HomeProc1
